<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>                         
        </div>

        <div class="pl-3 pt-3 pr-3" style="height: 80vh;">                
            <template>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            ref="name" 
                            v-model="bonoForm.nombre" 
                            label="Nombre" 
                            outlined 
                            :rules="[() => !!bonoForm.nombre || 'Es necesario ingresar un nombre']"
                            hide-details="auto"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="bonoForm.descripcion"
                            outlined
                            label="Descripción"
                            >
                        </v-textarea>
                    </v-col>
                </v-row>
            </template>                    
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'" dark color="success" block height="40" @click="handleStore">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Guardar
                        </v-btn>
                        <v-btn v-if="action == 'update'" dark color="success" block height="40" @click="handleUpdate">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>               
            
        </div>

    </v-navigation-drawer>
</template>

<script>
import { mapActions} from 'vuex'
    
export default {
    name: 'CreateUpdate',
    data() {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            bonoForm: {
                id: null,
                nombre: null,
                descripcion: null,
            }
        }
    },
    methods: {
        ...mapActions('bonos',[
            'store',
            'update'
        ]),
        async showForm(title, action, bono = null) {
            await this.clearData();
            this.titleForm = title;
            this.action = action;
            if (bono) {
                this.setBono(bono)
            }
            this.drawer = !this.drawer;
        },
        clearData() {
            this.titleForm = null;
            this.action = null;
            //this.bonoForm = null;
            this.bonoForm.nombre = null;
            this.bonoForm.descripcion = null;
            //this.clearErrors();
        },
        setBono(bono) {
            this.bonoForm.id = bono.id;
            this.bonoForm.nombre = bono.nombre;
            this.bonoForm.descripcion = bono.descripcion;
        },
        closeForm() {
            this.clearData();
            this.drawer = false;
        },
        handleCancel() {
            this.closeForm();
        },
        async handleStore() {
             await this.store(this.bonoForm)
                this.closeForm();
            /*if (!this.existErrors()) {
               
            }*/
        },
        async handleUpdate() {
            await this.update(this.bonoForm);
                this.closeForm();
            /*if (!this.existErrors()) {
                await this.store(this.bonoForm);
                this.closeForm();
            }*/
        },
        /*existsErrors() {
            let hasErrors = false;

            object.keys(this.bonoForm).forEach(f => {
                if (this.$refs[f]) {
                    if (!this.bonoForm[f]) hasErrors = true
                        this.$refs[f].validate(true);
                }
            }); 
        },
        clearErrors() {
            Object.keys(this.brandForm).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },*/
    }
    
}
</script>

<style scoped>
</style>